<template>
    <div class="p-compare-reserve__average-diff-table">
        <table class="a-table a-table--full-width">
            <tr>
                <th>
                    {{headingLabels.from}} vs {{headingLabels.to}}
                </th>
                <th>
                    Amount (&pound;)
                </th>
            </tr>
            <tr>
                <td>
                    <div class="u-d-flex u-align-items">
                        <span class="u-margin-right-10" :style="'background: ' + colours[0]"></span>
                        <div>{{fromLabel}}</div>
                    </div>
                </td>
                <td>
                    <div>{{currencyFormat(averageFrom)}}</div>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="u-d-flex u-align-items">
                        <span class="u-margin-right-10" :style="'background: ' + colours[1]"></span>
                        <div>{{toLabel}}</div>
                    </div>
                </td>
                <td>
                    <div>{{currencyFormat(averageTo)}}</div>
                </td>
            </tr>
            <tr>
                <td>
                    <div class="u-d-flex u-align-items">
                        <span class="u-margin-right-10" :style="'background: ' + colours[2]"></span>
                        <div>Difference</div>
                    </div>
                </td>
                <td>
                    <div>{{currencyFormat(Math.abs(difference))}}</div>
                    <div class="p-compare-reserve__average-diff-table--percent">
                        (<span>{{roundValue(differencePercent)}}% average difference</span>)
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import currencyFormat from "mixins/currencyFormat";
    import roundValue from "mixins/roundValue";

    export default {
        name: "difference-table",
        mixins: [
            currencyFormat,
            roundValue
        ],
        props: {
            colours: {
                type: Array,
                required: true
            },
            fromLabel: {
                type: String,
                required: true
            },
            toLabel: {
                type: String,
                required: true
            },
            difference: {
                type: Number,
                required: true
            },
            averageFrom: {
                type: Number,
                required: true
            },
            averageTo: {
                type: Number,
                required: true
            }
        },
        computed: {
            ...mapGetters('reserves/compare', [
                'from',
                'to'
            ]),
            headingLabels() {
                let from = 'Reserve';
                let to = 'Paid';
                if (this.from === 'paid') {
                    from = 'Paid';
                }
                if (this.to !== 'paid') {
                    to = 'Reserve';
                }
                return {from, to};
            },
            differencePercent() {
                return (1 - (
                    Math.min(this.averageTo, this.averageFrom) /
                    Math.max(this.averageTo, this.averageFrom)
                )) * 100;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// DifferenceTable.vue?5f49dc1e